import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "family"
const FamilyIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M10.5 7.313C13.536 7.313 16.465 8.436 18.721 10.467L19.047 10.761 21.217 11.575C21.878 11.82 22.313 12.45 22.314 13.155V15.75C22.313 16.268 21.893 16.688 21.375 16.688H19.898C19.444 17.472 18.596 18 17.625 18S15.806 17.472 15.352 16.688H8.272C7.82 17.472 6.973 18 6 18S4.181 17.472 3.727 16.688H2.625C2.107 16.688 1.688 16.267 1.688 15.75V11.479L1.926 11.052 2.668 8.327C2.53 8.225 2.438 8.06 2.438 7.875 2.438 7.565 2.689 7.313 3 7.313zM6 14.25C5.379 14.25 4.875 14.754 4.875 15.375S5.379 16.5 6 16.5 7.125 15.996 7.125 15.375 6.621 14.25 6 14.25M17.625 14.25C17.004 14.25 16.5 14.754 16.5 15.375S17.004 16.5 17.625 16.5 18.75 15.996 18.75 15.375 18.246 14.25 17.625 14.25M2.813 11.828V12.563H3.375C3.685 12.563 3.938 12.814 3.938 13.125 3.938 13.435 3.686 13.688 3.375 13.688H2.813V15.562H3.383Q3.376 15.47 3.375 15.376C3.375 13.925 4.55 12.75 6 12.75S8.625 13.925 8.625 15.375Q8.624 15.47 8.617 15.563H15.008Q15.001 15.47 15 15.375C15 13.925 16.175 12.75 17.625 12.75S20.25 13.925 20.25 15.375Q20.249 15.47 20.242 15.563H21.187V14.063H21C20.69 14.063 20.438 13.81 20.438 13.5S20.689 12.938 21 12.938H21.142C21.083 12.798 20.971 12.683 20.822 12.628L18.649 11.812H5.254zM3.187 10.7 4.687 10.69V8.436H3.806zM5.813 10.687H9.938V8.438H5.812zM11.063 10.688H17.22C15.44 9.346 13.296 8.564 11.063 8.452z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default FamilyIcon
